export default __webpack_public_path__ + "2708288.png";